import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StockFeatureDefinition } from '@digiwall/goliath-products/config';
import { BreadcrumbDefinition } from 'xng-breadcrumb/lib/types';

const routes: Routes = [
  {
    path: 'stock',
    data: {
      breadcrumb: {
        skip: true,
      } as BreadcrumbDefinition,
    },
    canMatch: [StockFeatureDefinition],
    loadChildren: () =>
      import('../documents/stock-docs/stock-doc.module').then(m => m.StockDocModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GoliathDocumentsStockRoutingModule {}
